import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useLink from 'Hooks/useLink';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import React from 'react';
import ExpenseRedesign from './ExpenseRedesign';

const ExpenseContainer = () => {
  const { householdResource } = useSimpleHousehold();
  const { collection, refreshCollection } = useLink(householdResource.relationship(fr.relationships.expenseCategories.name).link('related'));

  return (
    <DataContainer
      component={ExpenseRedesign}
      loading={!collection}
      componentProps={{
        collection,
        refreshCollection,
      }}
    />
  );
};

export default ExpenseContainer;
